import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SurveillancesService } from '../surveillances.service';

@Component({
  selector: 'app-buildinglist',
  templateUrl: './buildinglist.component.html',
  styleUrls: ['./buildinglist.component.scss']
})
export class BuildinglistComponent implements OnInit {
  campusId: any;
  buildingList: any;
  constructor(public dialogRef: MatDialogRef<BuildinglistComponent>,@Inject(MAT_DIALOG_DATA) public data: any,private dashboard: SurveillancesService, ){

  }
  ngOnInit(): void {
  this.campusId = this.data.campusId;
 this.dashboard.getbuildingdashboard(this.campusId).subscribe({
  next: (res: any) => {
    this.buildingList = res;
  },
  error: (err: any) => {
    console.error('Building list error:', err);
    this.buildingList = [];  
  }
});
  }

}
